// extracted by mini-css-extract-plugin
export default {"root":"NotifyCopyLink_root__X5G5h","layout-container":"NotifyCopyLink_layout-container__19JRN","content":"NotifyCopyLink_content__qdejk","buttonCopy":"NotifyCopyLink_buttonCopy__9M-r6","buttonClose":"NotifyCopyLink_buttonClose__LaYoD","openLink":"NotifyCopyLink_openLink__C366-","linkContainer":"NotifyCopyLink_linkContainer__B+0ds","linkImage":"NotifyCopyLink_linkImage__1hB7f"};
    if(module.hot) {
      // 1763446807909
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  